import i18n from "../translations/i18n";

function toSnakeCase(string, plural = false) {
  if (!string) return "";

  const converted = string.replace(/([a-z\d])([A-Z])/g, "$1_$2").toLowerCase();
  if (plural) return pluralize(converted);
  else return converted;
}

function toPascalCase(string) {
  return (
    string.charAt(0).toUpperCase() +
    string.slice(1).replace(/_([a-z])/g, (_, p) => p.toUpperCase())
  );
}

function pluralize(noun) {
  if (noun.match(/sis$/)) {
    return noun.replace(/sis$/, "ses");
  } else if (noun.match(/(x|ch|ss|sh)$/)) {
    return noun.replace(/(x|ch|ss|sh)$/, "$1es");
  } else if (noun.match(/([^aeiouy]|qu)y$/)) {
    return noun.replace(/([^aeiouy]|qu)y$/, "$1ies");
  } else {
    return noun.replace(/$/, "s");
  }
}

function checkTranslation(key) {
  if (key && key.includes("$t$")) {
    return i18n.te(`custom.${key.split("$t$")[1]}`);
  } else {
    return key && typeof key === "string" && key.length > 0;
  }
}

function getTranslation(key) {
  if (!key) {
    return "";
  } else if (key.split("$t$").length > 1) {
    return i18n.t(`custom.${key.split("$t$")[1]}`);
  } else {
    return key;
  }
}

function toSelect(input, customTrans = false) {
  if (input == null) {
    return [];
  }

  if (Array.isArray(input)) {
    return input.map((item) => ({
      value: item.key,
      text: customTrans
        ? getTranslation(item.text)
        : i18n.te(item.text)
          ? i18n.t(item.text)
          : item.text,
    }));
  }
  return Object.keys(input).map((key) => {
    return {
      value: key,
      text: customTrans
        ? getTranslation(input[key])
        : i18n.te(input[key])
          ? i18n.t(input[key])
          : input[key],
    };
  });
}

function capitalize(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function removeAccents(string) {
  return string.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

function customFilter(_item, queryText, itemText) {
  return removeAccents(itemText.toLowerCase()).includes(
    removeAccents(queryText.toLowerCase())
  );
}

function convertFileSize(size) {
  if (!size) return "";

  if (size >= 1048576) {
    return `${Math.round(size / 1048576)} MB`;
  } else {
    return `${Math.ceil(size / 1024)} kB`;
  }
}

function translateDuration(value) {
  if (!value) return;

  const split = value.split(".");
  return i18n.tc(split[1].toLowerCase(), parseInt(split[0]));
}

export {
  toSnakeCase,
  toPascalCase,
  pluralize,
  getTranslation,
  checkTranslation,
  toSelect,
  capitalize,
  removeAccents,
  customFilter,
  convertFileSize,
  translateDuration,
};
